import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listContestStage: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listContestStage (
            limit: 999
            sorters: [{ name: "number" order: ASC }]
          ) {
            items {
              id
              number
              contest {
                finish
              }
              title {
                current
              }
              form {
                schema
              }
            }
          }
        }
      `,
    }),
  ),

  listMyContestApplication: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listMyContestApplication (
            limit: 999
          ) {
            items {
              id
              stage {
                id
              }
              data
              # evaluation {
              #   sum
              # }
              state
            }
          }
        }
      `,
    }),
  ),
})
